import React from 'react';
import Icon from 'utils/components/icon';
import { User } from '../../../../state/types';
import { Timeline, UserInfo } from '../../../../dashboard/components';
import { getActionColor } from '../index';
import MessageLogInfo from '../message-log-info';
import { MESSAGE_ACTION_ICONS_MAPPER } from '../audit-log-modal-constants';

interface Props {
  messageEvent: any;
  user: User;
  userDisplayName: string;
}

const UserMessageEvent: React.FC<Props> = ({ messageEvent, user, userDisplayName }) => {
  const { published, timestamp, action, currentState } = messageEvent;
  // In case the author made any actions on his own comment, we'll take currentState as the actual action.
  const actualAction = action === 'moderated' ? currentState : action;
  const iconName = MESSAGE_ACTION_ICONS_MAPPER[actualAction];

  return (
    <Timeline.Item>
      <MessageLogInfo
        icon={<Icon className={`${iconName}-icon`} name={iconName} />}
        title={actualAction}
        timestamp={timestamp}
        published={published}
        color={getActionColor(actualAction)}
      />
      <UserInfo user={user} userDisplayName={userDisplayName} description={user.getUserRole()} />
    </Timeline.Item>
  );
};

export default UserMessageEvent;
